import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import ApexFundingAccountResultContent
  from 'Components/ComponentLibrary/Organisms/ApexFundingAccountResultContent/ApexFundingAccountResultContent';

const useStyles = buildUseStyles('ApexFundingAccountResultTemplate', (() => ({
  root: {},
})));

const ApexFundingAccountResultTemplate = ({ className, resource }) => {
  const classes = useStyles();

  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      resource={resource}
      LayoutProps={{
        resource,
      }}
      layout={ApexFundingAccountResultContent}
    />
  );
};

ApexFundingAccountResultTemplate.defaultProps = {
  className: '',
};

ApexFundingAccountResultTemplate.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.object.isRequired,
};

export default ApexFundingAccountResultTemplate;
